import { Box, Skeleton } from '@mui/material';
import HeaderFallback from './components/header.fallback';

const GatewaySettingsFallback = () => {
    return (
        <HeaderFallback title="تنظیمات کلی">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    width: '100%',
                    maxWidth: 1280,
                    height: 400,
                    overflow: 'hidden',
                    border: '1px solid',
                    borderColor: 'border.main',
                    borderRadius: 2,
                }}
            >
                <Box
                    sx={{
                        width: { xs: '100%', md: '240px' },
                        height: { xs: '69px', md: '100%' },
                        p: { xs: 1, md: 2 },
                    }}
                >
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height="100%"
                    />
                </Box>

                <Box
                    sx={{
                        width: '100%',
                        flex: 1,
                        p: { xs: 2, md: 3 },
                    }}
                >
                    <Skeleton variant="rectangular" height="100%" />
                </Box>
            </Box>
        </HeaderFallback>
    );
};

export default GatewaySettingsFallback;
